export default __webpack_public_path__ + "static/page-layout.light-f64c5eff97c796de7a23ce67943e32a9f5ebf518a459a091528bc890a4257deb.png";